import { Col, Row } from "antd";
import overviewImg from "../../../../assets/staticImages/overview.png";
import styles from "./EventOverview.module.css";
import {
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import Modal from "../../../../components/modal/Modal";
import { MdDelete } from "react-icons/md";
import { useEffect, useState } from "react";
import {
  stats,
  // timeLeft,
  timeIconWhite,
  details,
  pin,
  editIcon,
  viewBtnIcon,
  personArr,
} from "./Data";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { roles } from "../../../../config/roles";
import {
  CalendarIcon,
  ClockIcon,
  EditIcon,
  LocIcon,
  UserIcon,
} from "../../../../components/icons/Icons";
import brideImg from "../../../../assets/staticImages/bride.png";
import bubblesImg from "../../../../assets/bubbles.png";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import Storage from "../../../../utills/AsyncStorage";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import placeHolder from "../../../../assets/imageplace.jpg";
import moment from "moment";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import { phoneFormat } from "../../../../utills";
import dummyImg from "../../../../assets/dummy.jpg";
const LiveModal = ({ setLiveModalOpen }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();

  const goLive = () => {
    let eventData = {
      event_id: state?.eventData?.id,
    };
    dispatch(EventMiddleware.goLive(eventData))
      .then((data) => {
        navigate("/events/eventDetail/liveStream", {
          state: {
            data,
          },
        });
      })
      .catch((err) => console.log(err));
  };

  return (
    <Row className={styles.modalContentRow}>
      <Col>
        <svg
          className={styles.svgIcon}
          viewBox="0 0 318 219"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M262.459 184.391C262.459 190.06 262.568 193.434 262.432 196.808C261.926 209.335 253.238 218.556 240.78 218.624C197.053 218.843 153.339 218.829 109.612 218.651C96.7988 218.597 87.701 209.376 87.6053 196.508C87.3868 167.602 87.3868 138.697 87.6053 109.791C87.701 96.9368 96.8125 87.7296 109.626 87.675C153.121 87.4974 196.616 87.5111 240.111 87.675C253.293 87.7296 262.09 96.9368 262.459 110.215C262.541 113.357 262.473 116.512 262.473 121.649C267.309 119.927 271.434 119.149 274.781 117.113C282.95 112.155 290.477 106.117 298.823 101.554C302.293 99.6552 308.14 98.7263 311.2 100.434C314.287 102.141 316.828 107.633 316.882 111.513C317.361 139.271 317.361 167.042 316.882 194.8C316.814 198.68 314.26 204.171 311.172 205.879C308.112 207.573 302.266 206.63 298.796 204.745C290.449 200.183 282.895 194.158 274.754 189.172C271.53 187.178 267.555 186.317 262.459 184.391ZM240.329 109.955C196.438 109.955 153.107 109.955 109.968 109.955C109.968 139.189 109.968 167.93 109.968 196.522C153.695 196.522 196.862 196.522 240.329 196.522C240.329 167.575 240.329 138.997 240.329 109.955ZM262.773 164.761C276.352 160.54 284.698 170.28 294.848 175.867C294.848 160.349 294.848 145.773 294.848 130.104C284.657 137.003 275.874 145.377 262.773 141.798C262.773 149.734 262.773 156.469 262.773 164.761Z"
            className={styles.svgIconPath}
          />
          <path
            d="M0.125085 94.0819C1.60041 43.4426 46.1199 0.056938 96.363 0.166222C101.882 0.179882 107.018 1.58691 108.22 7.1194C108.999 10.7394 107.865 15.7528 105.652 18.7035C103.931 20.9848 99.2727 21.8044 95.8576 21.9547C61.0644 23.4846 31.7627 47.4861 23.9079 81.3503C22.8834 85.749 22.337 90.3253 22.0638 94.8332C21.4627 104.696 17.7198 109.655 10.6163 109.395C3.48556 109.163 -0.161785 103.835 0.125085 94.0819Z"
            className={styles.svgIconPath}
          />
          <path
            d="M43.8548 96.3368C44.3739 68.6061 68.8398 44.2768 96.5569 43.9353C104.002 43.8396 108.974 47.8422 109.357 54.2079C109.726 60.5464 105.136 65.1363 97.7863 65.751C79.0851 67.322 67.1322 79.1246 65.6842 97.4433C65.0832 105.066 60.9031 109.546 54.5236 109.424C47.8847 109.273 43.7182 104.178 43.8548 96.3368Z"
            className={styles.svgIconPath}
          />
          <path
            d="M202.476 153.177C191.316 153.164 186.193 149.858 186.002 142.536C185.797 134.941 191.152 131.321 202.572 131.307C203.706 131.307 204.84 131.293 205.96 131.307C213.883 131.484 218.732 135.678 218.705 142.29C218.678 148.888 213.801 153.013 205.864 153.177C204.73 153.205 203.61 153.177 202.476 153.177Z"
            className={styles.svgIconPath}
          />
        </svg>
      </Col>

      <Col>
        <TextComponent textClass={styles.modalText1}>
          Do You Want To
        </TextComponent>
        <TextComponent textClass={styles.modalText2}>Go Live</TextComponent>
        <div className={styles.modalBtnContainer}>
          <SubmitButton
            title="Yes"
            btnClass={styles.modalBtn}
            onClick={() => goLive()}
            // onClick={() => navigate("/events/eventDetail/liveStream")}
          />
          <SubmitButton
            title="No"
            outline={true}
            btnClass={styles.modalBtn}
            onClick={() => setLiveModalOpen(false)}
          />
        </div>
      </Col>
    </Row>
  );
};

const ShareModal = ({ setShareModalOpen }) => {
  const code = useRef(545654);
  const dispatch = useDispatch();

  async function copyTextToClipboard(text) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    }
  }

  // onClick handler function for the copy button
  const handleCopyClick = () => {
    // Asynchronously call copyTextToClipboard
    if (code.current) {
      copyTextToClipboard(code.current)
        .then(() => {
          dispatch(showAlert({ type: "Success", message: "Code Copied" }));
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <Row className={styles.modalContentRow}>
      {/* <MdDelete className={styles.deleteIcon} /> */}
      <Col>
        <svg
          className={styles.svgIcon}
          viewBox="0 0 297 303"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M198.307 152.028C198.307 199.669 198.191 247.309 198.438 294.95C198.468 301.001 196.995 302.762 190.9 302.732C129.911 302.496 68.9215 302.525 7.94664 302.718C2.21658 302.732 0.0441117 301.652 0.058692 295.202C0.248236 199.684 0.248236 104.151 0.058692 8.61799C0.0441117 2.52235 1.64795 0.820901 7.69877 0.835697C68.6882 1.05763 129.663 1.10201 190.652 0.791311C197.403 0.761721 198.468 2.95141 198.438 9.10623C198.191 56.7469 198.307 104.387 198.307 152.028ZM37.4572 67.3107C43.8434 73.4063 48.8007 78.3923 54.0496 83.0528C56.7469 85.4496 57.4176 87.8168 56.6157 91.3973C55.0848 98.2623 54.1662 105.275 52.7957 113.383C60.115 109.669 66.5886 106.607 72.8436 103.145C76.1533 101.31 78.9382 101.207 82.2916 103.071C88.532 106.548 94.9911 109.61 102.34 113.339C101.027 105.645 100.327 99.076 98.7091 92.7437C97.4843 87.9796 98.7382 84.991 102.267 81.9579C107.268 77.6525 111.817 72.8441 117.561 67.2811C109.017 66.0087 102.179 64.6919 95.2681 64.0557C91.069 63.671 88.9694 61.6885 87.2927 58.0193C84.5078 51.9088 81.2273 46.0203 77.5385 38.8446C73.733 46.331 70.3941 52.471 67.478 58.8034C65.9908 62.0583 63.935 63.5971 60.4503 64.0113C53.3351 64.8251 46.2783 66.0087 37.4572 67.3107ZM99.1756 221.003C117.809 221.003 136.428 220.856 155.062 221.107C159.698 221.166 161.871 219.953 161.273 215.026C161.069 213.34 161.011 211.549 161.273 209.877C162.352 203.205 159.451 201.814 153.225 201.858C118.626 202.169 84.0413 202.006 49.4422 202.021C37.0344 202.021 37.3697 202.051 37.0198 214.301C36.8594 220.042 38.7694 221.225 44.0183 221.137C62.4041 220.811 80.7899 221.003 99.1756 221.003ZM86.724 246.111C74.1704 246.111 61.6167 246.111 49.0631 246.111C37.0635 246.111 37.4134 246.126 37.0198 257.932C36.8156 263.895 38.7694 265.271 44.3537 265.212C70.9044 264.931 97.4697 265.241 124.035 265.034C137.741 264.931 136.035 268.171 136.487 252.014C136.632 246.94 134.664 245.948 130.188 246.022C115.695 246.259 101.217 246.111 86.724 246.111ZM74.7244 176.884C84.8723 176.884 95.0494 176.603 105.183 177.002C110.315 177.195 112.269 175.523 111.554 170.404C111.321 168.717 111.321 166.942 111.554 165.255C112.342 159.529 110.184 157.68 104.381 157.798C86.2575 158.168 68.1196 157.931 49.9817 157.931C36.4366 157.931 36.5824 157.931 37.0635 171.913C37.1947 175.774 38.332 177.002 42.0937 176.929C52.9706 176.751 63.8475 176.884 74.7244 176.884ZM160.515 98.1587C146.751 99.727 140.423 92.3738 136.239 80.9075C133.075 93.5574 125.187 98.7653 112.429 98.425C123.306 105.305 125.683 114.404 120.784 126.477C127.082 123.547 131.675 119.715 136.239 119.745C141.065 119.775 145.862 123.488 152.102 126.225C147.524 114.463 149.113 105.26 160.515 98.1587Z"
            className={styles.svgIconPath}
          />
          <path
            d="M223.066 298.352C223.066 288.824 223.066 279.296 223.066 269.768C223.066 205.201 223.066 140.65 223.066 76.0835C223.066 67.887 223.096 67.8574 230.765 70.6833C251.192 78.1992 271.604 85.7892 292.06 93.2164C295.749 94.5628 297.528 95.6724 295.808 100.451C272.275 165.55 248.99 230.753 225.618 295.911C225.297 296.799 224.729 297.612 224.277 298.456C223.883 298.411 223.475 298.382 223.066 298.352Z"
            className={styles.svgIconPath}
          />
        </svg>
      </Col>

      <Col>
        <TextComponent textClass={styles.modalText1}>
          Share Invitation Code To
        </TextComponent>
        <TextComponent textClass={styles.modalText2}>Guests!!</TextComponent>
        <Row className={styles.codeInputRow}>
          <Col xs={22}>
            <TextComponent textClass={styles.code}>
              {code.current}
            </TextComponent>
          </Col>
          <Col xs={2}>
            <div onClick={handleCopyClick} style={{ cursor: "pointer" }}>
              {pin}
            </div>
          </Col>
        </Row>
        <div className={styles.modalBtnContainer}>
          <SubmitButton title="Share" btnClass={styles.modalBtn} />
        </div>
      </Col>
    </Row>
  );
};

const LeftCol = ({ timeLeft }) => {
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [personModalOpen, setPersonModalOpen] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const personArr = [
    {
      data: EventDetails?.bride,
      name: "Bride",
    },
    {
      data: EventDetails?.groom,
      name: "Groom",
    },
  ];
  const [currentPerson, setCurrentPerson] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const role = localStorage.getItem("role");
  // const { state } = useLocation();
  // console.log("currentPerson", currentPerson);
  const role = Storage.getERole("@role");
  const onPressYes = () => {
    setDeleteModalOpen(false);
    let EventData = {
      id: EventDetails?.id,
    };
    dispatch(EventMiddleware.deleteEvent(EventData))
      .then(() => navigate(-1))
      .catch((err) => console.log(err));
  };

  const stats = [
    {
      title: "Tasks",
      current:
        EventDetails?.checklists?.length > 0
          ? EventDetails?.checklists?.filter((data) => data.is_completed)
              ?.length
          : "0",
      total:
        EventDetails?.checklists?.length > 0
          ? EventDetails?.checklists?.length
          : "0",
    },
    {
      title: "Guests Attending",
      current: EventDetails?.no_of_attendee
        ? EventDetails?.no_of_attendee
        : "0",
      total: EventDetails?.no_of_guest ? EventDetails?.no_of_guest : "0",
    },
    {
      title: "Budget",
      current:
        EventDetails?.budgets?.paid > EventDetails?.budgets?.total_budget
          ? EventDetails?.budgets?.total_budget
          : EventDetails?.budgets?.paid
          ? EventDetails?.budgets?.paid
          : "0",
      total: EventDetails?.budgets?.total_budget
        ? EventDetails?.budgets?.total_budget
        : "0",
      paid: EventDetails?.budgets?.paid ? EventDetails?.budgets?.paid : 0,
      unit: "$",
    },
  ];
  const openGmail = (email) => {
    const subject = encodeURIComponent("");

    const sender = encodeURIComponent(email);
    const body = encodeURIComponent("");

    const url = `https://mail.google.com/mail/?view=cm&fs=1&su=${subject}&to=${sender}&body=${body}`;

    window.open(url, "_blank");
  };
  async function copyTextToClipboard(text) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    }
  }
  const handleCopyClick = (link) => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard(link)
      .then(() => {
        dispatch(
          showAlert({
            type: "Success",
            message: "Copied",
          })
        );
        // If successful, update the isCopied state value
        setIsCopied(true);
        // setIsCopyModalOpen(false)
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      <div className={styles.imageContainer}>
        <img
          src={EventDetails?.image ? EventDetails?.image : placeHolder}
          alt="overviewImg"
          className={styles.eventImage}
        />
        {(role === roles.client || role === roles.coHost) &&
          EventDetails?.count_down && (
            <>
              <div className={styles.imageText}>
                <div className={styles.timeBoxesBg}></div>
                <div className={styles.timeBoxes}>
                  {timeLeft.map((time) => (
                    <div className={styles.timeBox}>
                      <TextComponent textClass={styles.timeTitle}>
                        {time?.title}
                      </TextComponent>
                      <TextComponent textClass={styles.timeDuration}>
                        {time?.duration}
                      </TextComponent>
                    </div>
                  ))}
                </div>
                <div className={styles.lineSvgDiv}>
                  <svg
                    className={styles.lineSvg}
                    viewBox="0 0 240 41"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M68.5859 0.607422H11.6367C5.56159 0.607422 0.636719 5.53229 0.636719 11.6074V29.9509C0.636719 36.026 5.56158 40.9509 11.6367 40.9509H68.5859V38.9509H11.6367C6.66615 38.9509 2.63672 34.9215 2.63672 29.9509V11.6074C2.63672 6.63686 6.66616 2.60742 11.6367 2.60742H68.5859V0.607422ZM171.539 38.9509H228.637C233.607 38.9509 237.637 34.9215 237.637 29.9509V11.6074C237.637 6.63686 233.607 2.60742 228.637 2.60742H171.539V0.607422H228.637C234.712 0.607422 239.637 5.53229 239.637 11.6074V29.9509C239.637 36.0261 234.712 40.9509 228.637 40.9509H171.539V38.9509Z"
                      fill="var(--primary-color)"
                    />
                  </svg>
                </div>
                <div className={styles.date}>
                  {EventDetails?.count_down?.datetime
                    ? moment(EventDetails?.count_down?.datetime).format(
                        "MMM DD YYYY"
                      )
                    : "MM DD, YYYY"}
                </div>
              </div>
              <div
                className={styles.editIconBtn}
                onClick={() =>
                  navigate("/events/eventDetail/editCountdown", {
                    state: {
                      headrTitle: "Edit Countdown",
                      data: EventDetails,
                    },
                  })
                }
              >
                {/* {editIcon} */}
                <EditIcon size={22} />
              </div>
              <div
                className={styles.countdownBtn}
                onClick={() =>
                  navigate("/events/eventDetail/countdown", {
                    state: {
                      eventData: EventDetails,
                    },
                  })
                }
              >
                {viewBtnIcon}
              </div>
            </>
          )}
      </div>
      <TextComponent textClass={styles.overviewTitle}>
        {EventDetails?.name}
      </TextComponent>
      <TextComponent textClass={styles.overviewSubTitle}>
        Wedding Party
      </TextComponent>
      {role === roles.client || role === roles.coHost ? (
        <>
          <div>
            {stats.map((stat) => (
              <div className={styles.statContainer}>
                <Row justify="space-between">
                  <Col>
                    <TextComponent textClass={styles.stat}>
                      {stat.title}
                    </TextComponent>
                  </Col>
                  <Col>
                    <TextComponent>
                      {stat.unit}
                      {stat.paid ? stat.paid : stat.current} out of {stat.unit}
                      {stat.total}
                    </TextComponent>
                  </Col>
                </Row>
                <div className={styles.progressBar}>
                  <span
                    className={styles.progress}
                    style={{
                      width: `${(stat.current / stat.total) * 100}%`,
                    }}
                  ></span>
                </div>
              </div>
            ))}
          </div>
          <SubmitButton
            title="Delete Event"
            onClick={() => setDeleteModalOpen(true)}
          />
        </>
      ) : (
        <Row className={styles.personImageContainer}>
          {personArr?.map((person) => {
            // console.log("personnnnnnnnnnn", person);
            return (
              <Col key={person?.data?.id}>
                <div className={styles.personImageWrapper}>
                  <img
                    className={styles.personImage}
                    src={person?.data?.image ? person?.data?.image : dummyImg}
                  />
                  <img src={bubblesImg} className={styles.bubblesImg} />
                </div>
                <TextComponent textClass={styles.personName}>
                  {person?.name}
                </TextComponent>
                <TextComponent
                  textClass={styles.personDetails}
                  onClick={() => {
                    setCurrentPerson(person);
                    setPersonModalOpen(true);
                  }}
                >
                  View Details
                </TextComponent>
              </Col>
            );
          })}
        </Row>
      )}
      <Modal
        isModalOpen={deleteModalOpen}
        setIsModalOpen={setDeleteModalOpen}
        closable={true}
        pinkBg={true}
      >
        <Row className={styles.modalContent}>
          <Col xs={24}>
            <Row justify={"center"}>
              <MdDelete className={styles.deleteIcon} />
            </Row>
            <div>
              <TextComponent textClass={styles.modalText1}>
                Do you want to Delete
              </TextComponent>
              <TextComponent textClass={styles.modalText2}>Event</TextComponent>
            </div>
          </Col>
          <div className={styles.modalBtnContainer}>
            <SubmitButton
              title="Delete"
              btnClass={styles.modalBtn}
              onClick={onPressYes}
            />
            <SubmitButton
              title="Cancel"
              outline={true}
              btnClass={styles.modalBtn}
              onClick={() => setDeleteModalOpen(false)}
            />
          </div>
        </Row>
      </Modal>
      <Modal
        isModalOpen={personModalOpen}
        setIsModalOpen={setPersonModalOpen}
        closable={true}
        className={styles.personModalContent}
      >
        {/* <Row className={styles.modalContent}> */}
        <Row style={{ alignItems: "center" }}>
          <Col xs={16} sm={18}>
            <TextComponent textClass={styles.modalPersonTitle}>
              {currentPerson?.name}
            </TextComponent>
            <TextComponent textClass={styles.modalPersonName}>
              {currentPerson?.data?.name}
            </TextComponent>
            {/* <a onClick={()openGmail}>Email Us</a> */}
            <TextComponent
              style={{ cursor: "pointer" }}
              onClick={() => openGmail(currentPerson?.data?.email)}
            >
              {currentPerson?.data?.email}
            </TextComponent>
          </Col>
          <Col xs={8} sm={6}>
            <div className={styles.personImageWrapper}>
              <img
                className={styles.personImage}
                src={currentPerson?.data?.image}
              />
              <img src={bubblesImg} className={styles.bubblesImg} />
            </div>
          </Col>
        </Row>
        <Row gutter={[8, 8]} className={styles.modalDetails}>
          <Col xs={24}>
            {/* <Row className={styles.modalDetailRow}>
              <Col xs={24} sm={11}>
                <Row className={styles.modalIconTextRow} align={"middle"}>
                  <LocIcon size={30} />
                  <TextComponent textClass={styles.modalIconText}>
                    Location:
                  </TextComponent>
                </Row>
              </Col>
              <Col xs={{ span: 24, offset: 4 }} sm={{ span: 12, offset: 1 }}>
                <TextComponent textClass={styles.modalDetailText}>
                  Los Angeles, California
                </TextComponent>
              </Col>
            </Row> */}
          </Col>
          <Col xs={24}>
            <Row className={styles.modalDetailRow}>
              <Col xs={24} sm={11}>
                <Row className={styles.modalIconTextRow}>
                  <UserIcon size={30} />
                  <TextComponent textClass={styles.modalIconText}>
                    Contact:
                  </TextComponent>
                </Row>
              </Col>
              <Col
                xs={{ span: 24, offset: 4 }}
                sm={{ span: 12, offset: 1 }}
                onClick={() =>
                  handleCopyClick(phoneFormat(currentPerson?.data?.contact_no))
                }
              >
                <TextComponent textClass={styles.modalDetailText}>
                  {phoneFormat(currentPerson?.data?.contact_no)}
                </TextComponent>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* </Row> */}
        <Row className={styles.modalBtnContainer}>
          <SubmitButton
            title="Chat"
            btnClass={styles.modalBtn}
            // onClick={() => navigate("/inbox")}
            onClick={() =>
              navigate("/inbox", {
                state: {
                  activeKey: "1",
                  chatData: EventDetails,
                  screenType: "eventOverviewScreen",
                },
              })
            }
          />
        </Row>
      </Modal>
    </>
  );
};

const RightCol = ({ EventDetails }) => {
  const [liveModalOpen, setLiveModalOpen] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);

  const navigate = useNavigate();
  // const role = localStorage.getItem("role");
  const role = Storage.getERole("@role");

  return (
    <div className={styles.rightCol}>
      <div>
        <Row className={styles.detailRow}>
          <Col className={styles.leftDetailCol}>
            <CalendarIcon size={30} />
            <TextComponent textClass={styles.detailTitle}>
              Event Date:
            </TextComponent>
          </Col>
          <Col className={styles.detailValue}>
            <TextComponent>
              {EventDetails?.date
                ? moment(EventDetails?.date).format("LL")
                : "--"}
            </TextComponent>
          </Col>
        </Row>
        <Row className={styles.detailRow}>
          <Col className={styles.leftDetailCol}>
            <UserIcon size={30} />
            <TextComponent textClass={styles.detailTitle}>
              Guests:
            </TextComponent>
          </Col>
          <Col className={styles.detailValue}>
            <TextComponent>
              {EventDetails?.no_of_attendee}/{EventDetails?.no_of_guest}
            </TextComponent>
          </Col>
        </Row>
        <Row className={styles.detailRow}>
          <Col className={styles.leftDetailCol}>
            <ClockIcon size={30} />
            <TextComponent textClass={styles.detailTitle}>
              Ceremony Start Time:
            </TextComponent>
          </Col>
          <Col className={styles.detailValue}>
            <TextComponent>
              {EventDetails?.start_time
                ? moment(EventDetails?.start_time).format("LT")
                : "--"}
            </TextComponent>
          </Col>
        </Row>
        <Row className={styles.detailRow}>
          <Col className={styles.leftDetailCol}>
            <ClockIcon size={30} />
            <TextComponent textClass={styles.detailTitle}>
              Ceremony End Time:
            </TextComponent>
          </Col>
          <Col className={styles.detailValue}>
            <TextComponent>
              {EventDetails?.end_time
                ? moment(EventDetails?.end_time).format("LT")
                : "--"}
            </TextComponent>
          </Col>
        </Row>
        <Row className={styles.detailRow}>
          <Col className={styles.leftDetailCol}>
            <LocIcon size={30} />
            <TextComponent textClass={styles.detailTitle}>
              Ceremony Location:
            </TextComponent>
          </Col>
          <Col className={styles.detailValue}>
            <TextComponent>
              {EventDetails?.address ? EventDetails?.address : "--"}
            </TextComponent>
          </Col>
        </Row>
        <Row className={styles.detailRow}>
          <Col className={styles.leftDetailCol}>
            <ClockIcon size={30} />
            <TextComponent textClass={styles.detailTitle}>
              Reception Start Time:
            </TextComponent>
          </Col>
          <Col className={styles.detailValue}>
            <TextComponent>
              {EventDetails?.reception_start_time
                ? moment(EventDetails?.reception_start_time).format("LT")
                : "--"}
            </TextComponent>
          </Col>
        </Row>
        <Row className={styles.detailRow}>
          <Col className={styles.leftDetailCol}>
            <ClockIcon size={30} />
            <TextComponent textClass={styles.detailTitle}>
              Reception End Time:
            </TextComponent>
          </Col>
          <Col className={styles.detailValue}>
            <TextComponent>
              {EventDetails?.reception_end_time
                ? moment(EventDetails?.reception_end_time).format("LT")
                : "--"}
            </TextComponent>
          </Col>
        </Row>
        <Row className={styles.detailRow}>
          <Col className={styles.leftDetailCol}>
            <LocIcon size={30} />
            <TextComponent textClass={styles.detailTitle}>
              Reception Location:
            </TextComponent>
          </Col>
          <Col className={styles.detailValue}>
            <TextComponent>
              {EventDetails?.reception_address
                ? EventDetails?.reception_address
                : "--"}
            </TextComponent>
          </Col>
        </Row>
        {/* <Row className={styles.detailRow}>
          <Col xs={24} sm={8} xl={6} className={styles.leftDetailCol}>
            <UserIcon size={30} />
            <TextComponent textClass={styles.detailTitle}>Event:</TextComponent>
          </Col>
          <Col className={styles.detailValue}>
            <TextComponent>Wedding</TextComponent>
          </Col>
        </Row> */}
        <div className={styles.detailText}>
          <TextComponent textClass={styles.detailTextHeading}>
            About Event
          </TextComponent>
          <p className={styles.detailTextParagraph}>
            <TextComponent>{EventDetails?.description}</TextComponent>
          </p>
        </div>
      </div>
      <div>
        <Row gutter={[12, 16]}>
          {
            role == roles.client || role === roles.coHost ? (
              <>
                <Col xs={24} sm={12} xl={8}>
                  <SubmitButton
                    title="Go Live"
                    onClick={() => setLiveModalOpen(true)}
                  />
                </Col>
                {/* <Col xs={24} sm={12} xl={8}>
                <SubmitButton
                  title="Share Event"
                  onClick={() => setShareModalOpen(true)}
                />
              </Col> */}
              </>
            ) : null
            // <Col xs={24} sm={12} xl={8}>
            //   <SubmitButton
            //     title="Save As Template"
            //     onClick={() => navigate("/templates/vendor")}
            //   />
            // </Col>
          }
        </Row>
      </div>
      {(role == roles.client || role === roles.coHost) && (
        <div className={styles.iconBtnContainer}>
          {EventDetails?.count_down && (
            <div
              className={styles.iconBtn}
              onClick={() =>
                navigate("/events/eventDetail/createCountdown", {
                  state: {
                    headrTitle: "Create Countdown",
                    clientDashBoardData: EventDetails,
                  },
                })
              }
            >
              {timeIconWhite}
            </div>
          )}
          <div
            className={styles.iconBtn}
            onClick={() =>
              navigate("/events/editEvent", {
                state: { headrTitle: "Edit Event" },
              })
            }
          >
            {editIcon}
          </div>
        </div>
      )}
      <Modal
        isModalOpen={liveModalOpen}
        setIsModalOpen={setLiveModalOpen}
        closable={true}
        pinkBg={true}
        wideModal={true}
      >
        <LiveModal setLiveModalOpen={setLiveModalOpen} />
      </Modal>
      <Modal
        isModalOpen={shareModalOpen}
        setIsModalOpen={setShareModalOpen}
        closable={true}
        pinkBg={true}
        wideModal={true}
      >
        <ShareModal setShareModalOpen={setShareModalOpen} />
      </Modal>
    </div>
  );
};

const EventOverview = () => {
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const countDownData = useSelector(
    (state) => state.DashboardReducer?.clientDashboardData
  );

  const { state } = useLocation();
  // console.log("eventOverView", state);
  const dispatch = useDispatch();
  // const EventDetails = state?.eventData;
  // console.log('eventDetails===========>>>>>>>', EventDetails);
  // console.log("renderrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr");
  // const startDate = moment(EventDetails?.count_down?.datetime);
  const [timeElapsed, setTimeElapsed] = useState({
    months: "00",
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });
  // console.log("timeElpassss",timeElapsed)
  let timerRef = null;
  function calculateTimeElapsed(data) {
    timerRef = setInterval(() => {
      var dur = moment.duration(
        moment(data?.count_down?.datetime).diff(moment())
      );
      let yearsRemain = dur.years();
      let months = dur.months();
      let days = dur.days();
      let hours = dur.hours();
      let minutes = dur.minutes();
      let seconds = dur.seconds();
      const timeObj = {
        months:
          months < 10 && yearsRemain == 0
            ? "0" + months
            : months + 12 * yearsRemain,
        days: days < 10 ? "0" + days : days,
        hours: hours < 10 ? "0" + hours : hours,
        minutes: minutes < 10 ? "0" + minutes : minutes,
        seconds: seconds < 10 ? "0" + seconds : seconds,
      };
      if (hours <= 0 && days <= 0 && months <= 0) {
        setTimeElapsed({
          months: "00",
          days: "00",
          hours: "00",
          minutes: "00",
          seconds: "00",
        });
        clearInterval(timerRef);
      } else {
        setTimeElapsed(timeObj);
      }
    }, 1000);
  }
  const timeLeft = [
    {
      title: "Mon",
      duration: EventDetails?.is_count_down ? timeElapsed?.months : "00",
    },
    {
      title: "Days",
      duration: EventDetails?.is_count_down ? timeElapsed?.days : "00",
    },
    {
      title: "Hrs",
      duration: EventDetails?.is_count_down ? timeElapsed?.hours : "00",
    },
  ];
  useEffect(() => {
    dispatch(
      EventMiddleware.getEventDetails({ id: state?.eventData?.id })
    ).then((data) => {
      calculateTimeElapsed(data);
    });
    return () => clearInterval(timerRef);
  }, []);

  return (
    <Row gutter={24} className={styles.overviewContainer}>
      <Col
        xs={{ span: 24 }}
        md={{ span: 24 }}
        lg={{ span: 8 }}
        xl={{ span: 7 }}
      >
        <LeftCol
          // EventDetails={EventDetails}
          timeLeft={timeLeft}
          // countDownData={countDownData}
        />
      </Col>
      <Col
        xs={{ span: 24 }}
        md={{ span: 24 }}
        lg={{ span: 16 }}
        xl={{ span: 17 }}
      >
        <RightCol EventDetails={EventDetails} />
      </Col>
    </Row>
  );
};

export default EventOverview;
